import dayjs from 'dayjs';
import { ESRI_FIELD_TYPES } from '../../../lib/constants';

export function generateFieldsMap(fields) {
  const fieldsMap = {};
  for (let fi = 0; fi < fields.length; fi++) {
    fieldsMap[fields[fi].name] = fields[fi];
  }
  return fieldsMap;
}

export function formatFieldValue(content, keyType, alias) {
  switch (keyType) {
    case ESRI_FIELD_TYPES.Date:
      return dayjs.unix(content / 1000).format('MMM D, YYYY');
    case ESRI_FIELD_TYPES.Double: {
      const formatted = Number(content).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return alias?.toLowerCase().includes('acre') ? `${formatted} acres` : formatted;
    }
    case ESRI_FIELD_TYPES.Integer: {
      const formatted = Number(content).toLocaleString();
      return alias?.toLowerCase().includes('acre') ? `${formatted} acres` : formatted;
    }
    default:
      return content;
  }
}
